module.exports = __webpack_public_path__ + "static/media/4-kreatywne-pomysły-na-ferie-w-domu.1be14230.png";